import type { DailyPositionDay, HistoryRange } from '@wave/shared';

export function daysForRange(range: HistoryRange): number {
  return { '24h': 14, '7d': 14, '30d': 30, '90d': 90, all: 366 }[range];
}

export interface DayCandle {
  date: string;
  /** ECharts candlestick: [open, close, lowest, highest]; '-' — пустые сутки. */
  candle: [number, number, number, number] | ['-', '-', '-', '-'];
  median: number | null;
  delta: number | null;
  /** Открытие или закрытие взяты не устойчивой точкой (шла операция). */
  unstable: boolean;
  samples: number;
}

export function toCandles(days: DailyPositionDay[]): DayCandle[] {
  return days.map((d) => {
    const complete = d.open && d.close && d.minUsdt !== null && d.maxUsdt !== null;
    return {
      date: d.date,
      candle: complete
        ? [Number(d.open!.positionUsdt), Number(d.close!.positionUsdt), Number(d.minUsdt), Number(d.maxUsdt)]
        : ['-', '-', '-', '-'],
      median: d.medianUsdt === null ? null : Number(d.medianUsdt),
      delta: d.open && d.close ? Number(d.close.positionUsdt) - Number(d.open.positionUsdt) : null,
      unstable: !!(d.open && !d.open.stable) || !!(d.close && !d.close.stable),
      samples: d.samples,
    };
  });
}

/** YYYY-MM-DD ± n суток (календарная арифметика в UTC — без DST-сюрпризов). */
export function shiftDate(iso: string, n: number): string {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

/** Текущая дата в поясе бизнеса (сутки сверки считает сервер в том же поясе). */
export function todayIn(tz: string, now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
}
